import { Injectable } from '@angular/core';
import { ErrorPopupComponent } from '../dialog/error-popup/error-popup.component';
import { NbDialogService, NbToastrService } from '@nebular/theme';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) { }

  popupError(error: any, message: string, complementary=''): void {
    if (error.status == 500){
      this.dialogService.open(ErrorPopupComponent, {
        context: {
          title: message,
          text: error.message,
          complementary: complementary,
        }
      })
    }    
  }

  toastTimeout(message: string): void {
    this.toastrService.show(message, "Timeout", { status: 'danger', icon: '' })
  }

}
